import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldOperatorDropdown } from '@/(routers)/boards/editor/block/definitions/fields/fieldOperatorDropdown';
import { FieldStyledBadgeLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledBadgeLabel';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

const POSITION_OPTIONS = {
    orange: {
        rectColour: CATEGORIES.sensing.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
    blue: {
        rectColour: CATEGORIES.sensing.color,
        options: [
            { value: 'UPPER_LEFT', label: '左上' },
            { value: 'LOWER_LEFT', label: '左下' },
            { value: 'UPPER_RIGHT', label: '右上' },
            { value: 'LOWER_RIGHT', label: '右下' },
        ],
    },
} as const;

defineBlock({
    type: 'temperature',
    colour: CATEGORIES.sensing.color,
    tooltip: '温度センサーの値を読み取ります',
    movable: true,
    deletable: true,
    output: 'Number',
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/temperature.svg', size: 65 } },
                {
                    type: 'field',
                    instance: () => new FieldStyledLabel('温度センサー', { fontSize: 15, fontWeight: 'bold' }),
                },
                {
                    type: 'field',
                    instance: () => new FieldStyledBadgeLabel('℃'),
                },
                { type: 'label', text: ' ' },
                {
                    type: 'dropdown',
                    name: 'POSITION',
                    rectColour: POSITION_OPTIONS.orange.rectColour,
                    options: [...POSITION_OPTIONS.orange.options],
                },
                { type: 'label', text: 'で計測する ' },
            ],
        },
    ],
    onBoardChange: (block, board) => {
        const field = block.getField('POSITION') as FieldOperatorDropdown | null;
        if (!field) return;
        field.setOptions([...POSITION_OPTIONS[board].options]);
    },
});
